import React, {useEffect, useReducer, useState} from 'react';
import close from "../images/Close.svg";
import Main from "./DataConnector/Main";
import SideBar from  "./DataConnector/SideBar"
import Permissions from "./DataConnector/Permissions";
import DbInfo from "./DataConnector/DbInfo";
import UploadFile from "./DataConnector/UploadFile";
import SelectEventLog from "./DataConnector/SelectEventLog";
import GenerateConnector from "./DataConnector/GenerateConnector";
import SourcePreview from "./DataConnector/SourcePreview";
import AddColumns from "./DataConnector/AddColumns";
import DataConnectorContext from './DataConnector/context/dataConnectorContext.js'
import Styles from "./DataConnector/DataConnector.module.scss"
import DataConnectorReducer from "./DataConnector/context/DataConnectorReducer";
import {initialState} from "./DataConnector/context/IntialState";
import LoadData from "./DataConnector/loadData";
import UploadErrorState from "./DataConnector/UploadErrorState";
import SaveModal from "./DataConnector/SaveModal";
import CloseModal from "./DataConnector/CloseModal";
import http from "../services/api/utilities/http";

export default function DataConnector(props) {
    const [state, dispatch] = useReducer(DataConnectorReducer, initialState);
    const [closeModal,setCloseModal] = useState(false)
    // useEffect(() => generateUid(), [])
    const generateUid = () => {
        http.post('data_connector/data_pool/', {})
            .then(res => {
                dispatch({type: 'set_connector_uid', value: res.data.data.id})
            })
            .catch(err => {
                console.log(err.response)
            })
    }
    return (
        <DataConnectorContext.Provider value={{dispatch,state}}>
        <div style={{zIndex: 999}} className="modal-parent d-flex justify-content-center align-items-center">
            <div className="modal-back"></div>
            <div className={['modal fade-in-top d-flex',Styles.wizard].join(' ')}>
                <img className={Styles.closeIcon} onClick={() => setCloseModal(true)} src={close} alt="close"/>
                {/*<SaveModal/>*/}
                {closeModal &&
                <CloseModal selfClose={() => setCloseModal(false)} close={props.close}/>
                }

                <SideBar/>
                <div className={Styles.rightContainer}>
                    {state.page === 'Assemble Input Source' && <Main/>}
                    {state.page === 'permissions' && <Permissions/>}
                    {state.page === 'Enter DB Info' && <DbInfo/>}
                    {state.page === 'Upload File' && <UploadFile/>}
                    {state.page === 'Source Preview' && <SourcePreview/>}
                    {state.page === 'Select Event Log' && <SelectEventLog/>}
                    {(state.page === 'Generate Connector' || state.page === 'Data Preview') && <GenerateConnector/>}
                    {state.page === 'Add Columns' && <AddColumns/>}
                    {state.page === 'Load Data' && <LoadData getData={props.getData}/>}
                    {state.page === 'Error' && <UploadErrorState/>}
                </div>
            </div>
        </div>
        </DataConnectorContext.Provider>
            );
}
